import { index, integer, pgEnum, pgTable, text, unique } from 'drizzle-orm/pg-core'
import { id } from '../utils/columns'
import { entities } from './entities.schema'

export const documentTypeEnum = pgEnum('document_type', [
  'quote',
  'invoice',
  'credit_note',
  'delivery_note',
  'quote_confirmation',
  'order_confirmation',
])
export type DocumentType = (typeof documentTypeEnum.enumValues)[number]

export const documentCounters = pgTable(
  'document_counters',
  {
    id,
    entityId: text('entity_id')
      .notNull()
      .references(() => entities.id),
    documentType: documentTypeEnum('document_type').notNull(),
    counter: integer('counter').notNull().default(0),
  },
  (table) => {
    return [
      index('idx_document_counters_entity_id').on(table.entityId),
      unique('uq_entity_document_type').on(table.entityId, table.documentType),
    ]
  },
)

export type DocumentCounter = typeof documentCounters.$inferSelect
export type DocumentCounterInsert = typeof documentCounters.$inferInsert
